export const REGEX = {
  // // Regex that accepts only alphabets in both small and capital case
  ONLY_ALPHABETS_REGEX: /^[a-zA-Z ]{2,30}$/,

  // // Email regex
  EMAIL_REGEX: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,

  NAME_REGEX: /^[A-Za-z\s]+$/,

  // /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,

  PASSWORD_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;:'",.<>?/`~.]{8,16}$/,

  CONTACT_REGEX: /^[0-9]{9}$/,

  //regex for integers or decimals
  INT_DEC_REGEX: /^[0-9]+(\.[0-9]+)?$/,

  // Regex for only whole numbers
  WHOLE_NUM_REGEX: /^[0-9]+$/,

  //allowed to type only numbers
  ONLY_NUMBERS_REGEX: /^[0-9]*\.?[0-9]*$/,

  // vat id validation
  VAT_ID_REGEX: /^\d{15}$/,

  // Postal code regex that accepts 5 or 9 digit postal codes with an optional hyphen
  POSTAL_CODE_REGEX: /^\d{1,10}(-\d{1,10})?$/,
};

export const WORK_ORDER = "Work Order";
export const SMALL_CASE_WORK_ORDER = "work order";
export const CAP_CASE_WORK_ORDER = "Work order";

export const ROLES = {
  ADMINISTRATOR: "ADMINISTRATOR",
  SPARE_PARTS: "SPARE_PARTS",
};

export const DEFAULT_ROUTES = {
  ADMINISTRATOR: "/admin/dashboard",
  SPARE_PARTS: "/admin/spare-parts",
};

//Default records per page
export const DEFAULT_RECORDS_PER_PAGE = 25;

// payments options
export const paymentOptions = [
  { value: 1, label: "CASH" },
  { value: 2, label: "CREDIT" },
];

export const roleOption = [
  { value: "Administrator", label: "Administrator" },
  // { value: "Moderator", label: "Moderator" },
  { value: "Spare Part", label: "Spare Part" },
];

//job status
export const JOB_STATUS = {
  JOB_CREATED: { value: "JOB_CREATED", label: `${WORK_ORDER} Created` },
  JOB_ALLOCATED: { value: "JOB_ALLOCATED", label: `${WORK_ORDER} Allocated` },
  QUOTATION_IN_PROGRESS: {
    value: "QUOTATION_IN_PROGRESS",
    label: "Quotation In Progress",
  },
  QUOTATION_SENT: { value: "QUOTATION_SENT", label: "Quotation Sent" },
  QUOTATION_APPROVED: {
    value: "QUOTATION_APPROVED",
    label: "Quotation Approved",
  },
  QUOTATION_ACCEPTED: {
    value: "QUOTATION_ACCEPTED",
    label: "Quotation Accepted",
  },
  QUOTATION_REJECTED: {
    value: "QUOTATION_REJECTED",
    label: "Quotation Rejected",
  },
  REQUEST_APPROVAL: { value: "REQUEST_APPROVAL", label: "Request Approval" },
  PART_REQUESTS: { value: "PART_REQUESTS", label: "Request Parts" },
  REPAIR: { value: "REPAIR", label: "Repair" },
  REPAIRED: { value: "REPAIRED", label: "Repaired" },
  COMPLETED: { value: "COMPLETED", label: "Completed" },
  CANCELLED: { value: "CANCELLED", label: "Cancelled" },
  TECHNICIAN_CHANGED: {
    value: "TECHNICIAN_CHANGED",
    label: "Technician Changed",
  },
  JOB_REJECTED_BY_CLIENT: { label: "Work Order Rejected By Client"},
  TECHNICIAN_ASSIGNED: {
    value: "TECHNICIAN_ASSIGNED",
    label: "Technician Assigned",
  },
  QUOTATION_CREATED: { value: "QUOTATION_CREATED", label: "Quotation Created" },
  PART_ON_ORDER: { value: "PART_ON_ORDER", label: "Parts On Order" },
  READY_FOR_PICKUP: { value: "READY_FOR_PICKUP", label: "Ready For Pickup" },
  PICKED_UP: { value: "PICKED_UP", label: "Picked Up" },
  REWORK_REQUIRED: { value: "REWORK_REQUIRED", label: "Rework Required" },
  JOB_COMPLETED: { value: "COMPLETED", label: `${WORK_ORDER} Completed` },
  JOB_UPDATED: { value: "JOB_UPDATED", label: `${WORK_ORDER} Updated` },
  PARTS_ORDERED: { value: "PARTS_ORDERED", label: "Parts Ordered" },
  JOB_CONTINUED: { value: "JOB_CONTINUED", label: `${WORK_ORDER} Continued` },
  JOB_CANCELLED: { value: "JOB_CANCELLED", label: `${WORK_ORDER} Cancelled` },
  SCHEDULED: { value: "SCHEDULED", label: "Scheduled" },
  RESCHEDULED: { value: "RESCHEDULED", label: `${WORK_ORDER} Rescheduled` },
  QUOTATION_REVISED: { value: "QUOTATION_REVISED", label: "Quotation Revised" },
  INVOICE_NOT_PAID: { value: "INVOICE_NOT_PAID", label: "Invoice (Not Paid)" },
  INVOICE_PAID: { value: "INVOICE_PAID", label: "Invoice (Paid)" },
  QUOTATION_REQUESTED_FOR_APPROVAL: {
    value: "QUOTATION_REQUESTED_FOR_APPROVAL",
    label: "Quotation Requested For Approval",
  },
  AWAITING_PAYMENT: { value: "AWAITING_PAYMENT", label: "Payment Awaiting" },
  QUOTATION_REVIEW_REMINDER_SENT: { value: "QUOTATION_REVIEW_REMINDER_SENT", label: "Quotation Review Reminder Sent" },
  PAYMENT_PAID: { value: "PAYMENT_PAID", label: "Payment Paid" },
  JOB_REOPEN: { value: "JOB_REOPEN", label: `${WORK_ORDER} Reopen` },
  FEEDBACK_RECEIVED: { value: "FEEDBACK_RECEIVED", label: "Feedback Received" },
  EQUIPMENT_UPDATED: { value: "EQUIPMENT_UPDATED", label: "Equipment Updated" }
};

// Custom style for react select
export const customStyle = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "38px",
    borderRadius: "0.4285rem",
    borderColor: state.selectProps.className?.includes("is-invalid")
      ? "#ec250d" // this is the same color as used in variable for $danger-states
      : "#d0d7de",
    color: "#222a42",
    boxShadow: state.isFocused ? "0 0 0 0 rgba(0,123,255,.25)" : "none",
    "&:hover": {
      borderColor: state.isFocused
        ? "#1d8cf8"
        : state.selectProps.className?.includes("is-invalid")
          ? "#ec250d"
          : "#d0d7de",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 18px",
    fontSize: "0.7500000025rem",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "33px",
  }),
  menu: (provided) => ({
    ...provided,
    maxHeight: "15rem",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "15rem",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

// fixed width Custom style for react select
export const fixedWidthCustomStyle = (extraWide = false) => ({
  container: (provided) => ({
    ...provided,
    width: window.innerWidth < 768 ? "100%" : extraWide ? "14rem" : "12rem",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "2.375rem",
    borderRadius: "0.4285rem",
    borderColor: "#d0d7de",
    color: "#222a42",
    boxShadow: state.isFocused ? "0 0 0 0 rgba(0,123,255,.25)" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#1d8cf8" : "#d0d7de",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 1.125rem",
    fontSize: "0.7500000025rem",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "2.0625rem",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgb(168 168 168)",
  })
});

// Add this custom style configuration alongside fixedWidthCustomStyle
export const selectStyles = {
  ...fixedWidthCustomStyle(),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // High z-index to appear above all content
    position: 'absolute',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "2.375rem",
    borderRadius: "0.4285rem",
    borderColor: "#d0d7de",
    color: "#222a42",
    boxShadow: state.isFocused ? "0 0 0 0 rgba(0,123,255,.25)" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#1d8cf8" : "#d0d7de",
    },
  }),
};

export const statusOptions = [
  { value: "ACTIVE", label: "Active" },
  { value: "SUSPENDED", label: "Suspended" },
];

export const discountType = [
  { value: "SERVICE_DISCOUNT", label: "Service Discount", smallCase: "service discount" },
  { value: "PART_DISCOUNT", label: "Part Discount", smallCase: "part discount" },
];

export const yellow = "#ffc107";
export const light = "#e4e5e9";

export const REACT_APP_GOOGLE_MAPS_API_KEY =
  "AIzaSyD_M-gysKYbGXX_8ftB1eZrOx0Zop91Jig";
//"AIzaSyA4UajnuZxo-1gBQ2iF7M1atR_qtSq36ng";

export const ratingOptions = [
  { value: 0, label: "0" },
  { value: 1, label: "1" },
  { value: 1.5, label: "1.5" },
  { value: 2, label: "2" },
  { value: 2.5, label: "2.5" },
  { value: 3, label: "3" },
  { value: 3.5, label: "3.5" },
  { value: 4, label: "4" },
  { value: 4.5, label: "4.5" },
  { value: 5, label: "5" },
];

export const sellerOptions = [
  { value: "FALCON", label: "FALCON" },
  { value: "OTHERS", label: "OTHERS" },
];

export const JOB_STATUS_OPTIONS = [
  // { value: "AWAITING_PAYMENT", label: "Awaiting Payment" },
  // { value: "AWAITING_PAYMENT_APPROVAL", label: "Awaiting Payment Approval" },
  // { value: "COLLECT_CASH", label: "Collect Cash" },
  // { value: "PENDING_APPROVAL", label: "Pending Approval" },
  { value: "JOB_CREATED", label: `${WORK_ORDER} Created` },
  { value: "JOB_ALLOCATED", label: `${WORK_ORDER} Allocated` },
  { value: "QUOTATION_IN_PROGRESS", label: "Quotation InProgress" },
  { value: "REQUEST_APPROVAL", label: "Request Approval" },
  { value: "QUOTATION_ACCEPTED", label: "Quotation Accepted" },
  { value: "QUOTATION_REJECTED", label: "Quotation Rejected" },
  { value: "PART_REQUESTS", label: "Request Parts" },
  { value: "REPAIR", label: "Repair" },
  { value: "REPAIRED", label: "Repaired" },
  { value: "INVOICE_NOT_PAID", label: "Invoice (Not Paid)" },
  { value: "JOB_REJECTED_BY_CLIENT", label: `${WORK_ORDER} Rejected By Client`  },
  { value: "INVOICE_PAID", label: "Invoice (Paid)" },
  { value: "CANCELLED", label: "Cancelled" },
  // { value: "COMPLETED", label: "Completed" },
];

export const QUOTATION_STATUS = [
  { value: "QUOTATION_CREATED", label: `Quotation Created` },
  { value: "QUOTATION_SENT", label: `Quotation Sent` },
  { value: "QUOTATION_REQUESTED_FOR_APPROVAL", label: "Quotation Requested for Approval" },
  { value: "QUOTATION_APPROVED", label: "Quotation Approved" },
  { value: "QUOTATION_ACCEPTED", label: "Quotation Accepted" },
  { value: "QUOTATION_REJECTED", label: "Quotation Rejected" },
  { value: "QUOTATION_REVISED", label: "Quotation Revised" },
  // { value: "COMPLETED", label: "Completed" },
];

export const MASTER_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];

// This style for service charges slider was not working with scss, that's way it's written in css
export const sliderStyles = {
  marginTop: "-0.2rem",
  width: 280,
  color: "default",
  "& .MuiSlider-thumb": {
    backgroundColor: "default",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  "& .MuiSlider-markLabel": {
    marginTop: "-0.2rem",
    fontSize: "0.75rem",
    color: "#777",
  },
};

export const PARTS_REQ_STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "IN-PROGRESS", label: "In Progress" },
  { value: "PART_ON_ORDER", label: "Parts On Order" },
  { value: "READY_FOR_PICKUP", label: "Ready For Pickup" },
  { value: "PICKED_UP", label: "Picked Up" },
  { value: "COMPLETED", label: "Completed" },
  // { value: "TRANSIT", label: "Transit" },
  // { value: "RETURN_PART_PENDING", label: "Return Part Pending" },
  // { value: "RETURN_PART_COMPLETE", label: "Return Part Complete" },
];
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB for image in product as well as for per document

export const MAX_VIDEO_SIZE = 50 * 1024 * 1024; // 500 MB fro video in technical report
export const ALLOWED_IMG_TYPES = [
  // for img
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/heif",
  "image/heic",
  "image/webp",
];
export const ALLOWED_VIDEO_TYPES = [
  // for videos
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-matroska",
  "video/matroska",
];

export const JobPriorityOptions = [
  { value: "HIGH", label: "HIGH" },
  { value: "MEDIUM", label: "MEDIUM" },
  { value: "LOW", label: "LOW" },
];

export const CREATED_BY = [
  { value: "ADMINISTRATOR", label: "Administrator" },
  { value: "CUSTOMER", label: "Customer" },
];

export const PAYMENT_TERMS_STATUS = {
  CREDIT: { value: "CREDIT", label: "Credit" },
  CASH: { value: "CASH", label: "Cash" },
};

export const PAYMENT_METHODS = {
  DB: { value: "Debit Card" },
  CC: { value: "Credit Card" },
};


export const INTERNAL_MONITORING_STATUS = [
  { value: "YES", label: `Yes` },
  { value: "No", label: `No` },
]

export const ASSIGN_STATUS_OPTIONS = [
  {
    label: "Assign",
    value: "ASSIGNED",
    color: "success"
  },
  {
    label: "Unassign",
    value: "UNASSIGNED",
    color: "warning"
  },
  {
    label: "All",
    value: "ALL",
    color: "secondary"
  },
];

export const MAX_MANUAL_JOB_IDS = 100;
